<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :mode="mode"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
  >
    <a-select-option
      v-for="item in records"
      :key="item.id"
      :title="keyName?item[keyName]:item.companyName"
      :value="keyName?item[keyName]:item.id"
    >
      {{ keyName?item[keyName]:item.companyName }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, PropType, reactive } from "vue";
// import { ProfileService } from "@/views/project/profile/profile.service";
// import { ProfileSimpleListReq,ProfileSimpleRecord } from "@/views/project/profile/profile.interface";

import { CompanyPageReq } from "@/views/cooperation/company/company.interface";
import { CompanyService } from "@/views/cooperation/company/company.service";

/**
 * 项目选择器
 *
 * 使用方式:
 * <project-select v-model:value="formRef.projectId"></project-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "CooperationSelect",
  props: {
    value: {
      type: String || Array,
      default: undefined,
    },
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },
    mode:{
      type: String,
      default:''
    },

    // 其他状态
    // 技术方案: skillSolutionValidStatus
    // 招标申请: bidValidStatus
    // 招标文件购买申请: bidFileApplyValidStatus
    // 保证金申请: assuringMoneyApplyProcessStatus
    // 招标报价: bidOfferValidStatus
    /**
     * 可能后续不会用到
     */
    otherStatus: {
      type: Array,
      default: () => [],
    },

    // 项目状态, 从字典中获取, 字典值: project_status
    projectStatus: {
      type: Array,
      default: () => [],
    },
    flowStatus: {
      type: Array,
      default: () => [],
    },
    api: {
      type: String,
    },
    // defaultItem:{
    //   type:Array as PropType<ProfileSimpleRecord[]>,
    //   default:()=>[],
    // },
    req: {
      type: Object,
      default: () => {},
    },
    typeAttributionList: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    keyName: {
      type: String,
      default: null,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    // const { data: dataSource, loading, run, refresh, pagination } = CompanyService.usePageApi();//所有数据
    let { data: records, run, loading } = CompanyService.usePageApi();
    const onChange = async (id) => {
      emit("update:value", id);
      emit("change", id);
    };
    const queryRef = reactive(new CompanyPageReq());
    queryRef.enable = true;

    const search = async () => {
      queryRef.current = 1;
      queryRef.size = 2000;
      //queryRef.typeAttributionList=props.typeAttributionList;
      await run(queryRef);
    };

    onMounted(async () => {
      await search();
      // const req = new ProfileSimpleListReq();
      // req.merge({
      //   projectStatus: props.projectStatus,
      //   otherStatus: props.otherStatus,
      //   flowStatus: props.flowStatus
      // });
      // req.merge(props.req)
      // await run(req, props.api);
      // let array:any  = JSON.parse(JSON.stringify(records.value));
      // props.defaultItem.forEach((item)=>{
      //   if(!array.find(value=>value.id == item.id)){
      //     array.push(item);
      //   }
      // });
      // //编辑技术方案时，回显使用
      // if(props.externalData.projectId&&props.externalData.projectName){
      //   array.push({id:props.externalData.projectId,name:props.externalData.projectName})
      // }
      // records.value = array;
    });

    return {
      records,
      loading,
      search,
      queryRef,
      onChange,
    };
  },
});
</script>
